import BqnContext from "common/BqnContext";
import React, { useContext, useState } from "react";
import Table from "common/graphs/Table/Table";
import { atoiv6, atoiv4 } from "common/utils";

const doesNothing = () => {};

const getColumns = ({ includeBqn, onDelete }) => {
  return [
    ...(includeBqn
      ? [
          {
            label: "BQN",
            id: "bqn",
            numeric: false,
          },
        ]
      : []),
    {
      label: "ALLOWED IP RANGES",
      id: "range",
      numeric: false,
      renderCell: (value, row) => {
        const { from, fromRaw } = row;
        return (
          <div>
            {value}
            {from || fromRaw ? (
              <span className="col-red">
                {fromRaw ? fromRaw : `Suggested to allow traffic from ${from}`}
              </span>
            ) : null}
          </div>
        );
      },
      parse: (value) => {
        if (!value) {
          return 0;
        }
        const [ip] = value.split("/");
        return ip.includes(":") ? atoiv6(ip) : atoiv4(ip);
      },
    },
    {
      label: "ACTIONS",
      id: "ACTIONS",
      actions: [
        {
          label: "Delete",
          icon: "delete",
          onClick: (row) => {
            onDelete([row["__id"]]);
          },
        },
      ],
    },
  ];
};

const RangesList = ({ items = [], onDelete = doesNothing }) => {
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const [selected, setSelected] = useState([]);
  const hasBqnColumn = mode === "cluster";

  if (items.length === 0) {
    return <h5>No firewall rules configured: all IP addresses allowed.</h5>;
  }

  const columns = getColumns({ includeBqn: mode === "cluster", onDelete });

  const filteredItems = items
    .filter(
      ({ deleted, bqn }) =>
        deleted !== true &&
        (!hasBqnColumn ||
          bqnId === "all" ||
          parseFloat(bqnId) === parseFloat(bqn)),
    )
    .map((item, index) => ({
      ...item,
      id: index,
    }));

  return (
    <Table
      isSelectable={true}
      isRowSelectable={false}
      data={filteredItems}
      sort={true}
      columns={columns}
      search={true}
      csvPrefix="configuration-rules"
      rowsPerPageNr={50}
      selected={selected}
      setSelected={setSelected}
      deleteSelected={(values) => {
        const selectedIds = filteredItems
          .filter((row) => values.includes(row.id))
          .map((row) => row.__id);
        onDelete(selectedIds);
        setSelected([]);
      }}
    />
  );
};
export default RangesList;
